import { MfeUserNavData } from '@platform-services/hrm-mfe-global'

export async function getMfe() {
  return await import('@/setup-mfe')
}

export async function getReportMfeRiskScore() {
  return await import('@/setup-mfe-risk-score')
}

export function onNavLoad() {
  return new MfeUserNavData({
    visibilityKeys: [],
    replacementNavItems: [],
  })
}
